import type { User } from '@core/entities/User';
import type {
  ChangePasswordPayload,
  ProfileRepository,
  UpdateProfilePayload,
} from '@core/repositories/ProfileRepository';
import { httpClient } from '@infrastructure/http/httpClient';
import { toAppError } from '@infrastructure/http/errorMapper';
import { toUser, type UserEnvelope } from '@infrastructure/mappers/toUser';

export class ProfileRepositoryImpl implements ProfileRepository {
  async update(payload: UpdateProfilePayload): Promise<User> {
    try {
      const response = await httpClient.put<UserEnvelope>('/profile', payload);
      return toUser(response.data.data);
    } catch (error) {
      throw toAppError(error);
    }
  }

  async changePassword(payload: ChangePasswordPayload): Promise<void> {
    try {
      await httpClient.put('/profile/password', {
        current_password: payload.currentPassword,
        password: payload.password,
        password_confirmation: payload.passwordConfirmation,
      });
    } catch (error) {
      throw toAppError(error);
    }
  }

  async uploadAvatar(file: File): Promise<User> {
    try {
      const form = new FormData();
      form.append('avatar', file);
      const response = await httpClient.post<UserEnvelope>('/profile/avatar', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return toUser(response.data.data);
    } catch (error) {
      throw toAppError(error);
    }
  }

  async deleteAvatar(): Promise<User> {
    try {
      const response = await httpClient.delete<UserEnvelope>('/profile/avatar');
      return toUser(response.data.data);
    } catch (error) {
      throw toAppError(error);
    }
  }
}
